import * as React from 'react';
import { makeStyles } from '@material-ui/core';
import { Build, Dashboard, Event, Public, ReceiptOutlined } from '@material-ui/icons';
import { NavLink } from 'react-router-dom';
import { AppRouting } from '../AppConstants';
import { SSMPalette } from './AppTheme';
import { authService } from '../index';
import { observer } from 'mobx-react';
import { LNG } from '../Services/LanguageService';

const useStyles = makeStyles((theme) => ({
    root: {
        overflow: 'hidden',
        width: '100%',
        whiteSpace: 'nowrap',
        borderTop: `solid 1px ${SSMPalette.gray.linen}`,
    },
    item: {
        minHeight: 40,
        display: 'flex',
        alignItems: 'center',
        borderBottom: `solid 1px ${SSMPalette.gray.linen}`,
        fontSize: 14,
        cursor: 'pointer',
        textDecoration: 'none',
        color: theme.palette.text.primary,

        transition: theme.transitions.create(
            ['background-color', 'color'],
            {
                duration: theme.transitions.duration.short,
            },
        ),
        '&:hover': {
            backgroundColor: SSMPalette.primary.main,
            color: SSMPalette.common.white,
        },
        '&:active': {
            backgroundColor: SSMPalette.primary.dark,
            color: SSMPalette.common.white,
        },
        '&:disabled': {
            backgroundColor: SSMPalette.primary.disabled,
            color: SSMPalette.primary.disabledText,
        },

    },
    icon: {
        flexBasis: 40,
        flexShrink: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        alignSelf: 'stretch',
    },
    active: {
        backgroundColor: theme.palette.primary.light,
        color: theme.palette.common.white,
    },
}));
type DrawerRoute = {
    url: string,
    icon: JSX.Element,
    label: string
}
export const Drawer = observer(() => {
    const classes = useStyles();
    const routes: DrawerRoute[] = [];

    if (authService.hasDashboardSubscription) {
        routes.push({
            url: AppRouting.Company,
            label: 'Dashboard.1',
            icon: <Public/>,
        });
        routes.push({
            url: AppRouting.Plant,
            label: 'Dashboard.2',
            icon: <Dashboard/>,
        });
        routes.push({
            url: AppRouting.Machine,
            label: 'Dashboard.3',
            icon: <Build/>,
        });
    }
    if (authService.isAdmin) {
        routes.push({
            url: AppRouting.Administration,
            label: 'Dashboard.4',
            icon: <Event/>,
        });
    }
    if (authService.hasRecipeManagementAccess) {
        routes.push({
            url: AppRouting.Recipe,
            label: 'Dashboard.5',
            icon: <ReceiptOutlined/>,
        });
    }

    const renderLink = (route: DrawerRoute) => {
        const { icon, label, url } = route;
        const { isAdmin } = authService;

        if (url === AppRouting.Administration && !isAdmin) {
            return null;
        }

        return (
            <NavLink key={url} className={classes.item} activeClassName={classes.active} to={url}>
                <div className={classes.icon}>{icon}</div>
                {LNG.Text(label)}
            </NavLink>
        );
    };

    return (
        <div className={classes.root}>{routes.map(r => renderLink(r))}</div>
    );
});
